import { type ReactElement } from 'react';
import {
  PLUGIN_SOURCE_TO_PLATFORM,
  type PluginSource,
} from '@kirin/api-client/contracts/plugins';
import { PlatformBadge } from '@/components/shared/platform/PlatformBadge';

interface PluginSourceBadgeProps {
  source: string;
}

/**
 * Badge for a plugin-inventory source. Delegates to the shared
 * {@link PlatformBadge} so the plugin table's source chip uses the SAME icon +
 * label resolution (platform-utils / the platform registry) as every other
 * screen — no per-source icon/label map to drift out of sync (that drift is how
 * the Codex chip lost its icon; KIR-3334).
 *
 * Plugin sources are not 1:1 with platform ids (`claude_code` → `claude`,
 * `claude_desktop_rpm` → `claude_desktop`), so map through the canonical
 * `PLUGIN_SOURCE_TO_PLATFORM` (the same table the column sort/filter use).
 * An unknown future source passes through to PlatformBadge's generic fallback.
 */
export function PluginSourceBadge({
  source,
}: PluginSourceBadgeProps): ReactElement {
  const platform = PLUGIN_SOURCE_TO_PLATFORM[source as PluginSource] ?? source;
  return <PlatformBadge platform={platform} showTooltip={false} />;
}
